import { render, staticRenderFns } from "./EspecialidadesComponent.vue?vue&type=template&id=d468243c&scoped=true"
import script from "./EspecialidadesComponent.vue?vue&type=script&lang=js"
export * from "./EspecialidadesComponent.vue?vue&type=script&lang=js"
import style0 from "./EspecialidadesComponent.vue?vue&type=style&index=0&id=d468243c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d468243c",
  null
  
)

export default component.exports